// extracted by mini-css-extract-plugin
module.exports = {"around":"qdrR3"};